var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"disabled":_vm.loading,"size":"small","type":"primary"},on:{"click":function($event){return _vm.addModel(_vm.date)}}},[_vm._v(" Обрати "+_vm._s(_vm.eventForm.models[_vm.date] ? _vm.eventForm.models[_vm.date].length > 0 ? 'іншу' : '' : '')+" модель на "+_vm._s(_vm.date)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }